const LookupValues = (state = { lookupFields: [] }, action) => {
  switch (action.type) {
    case 'SET_LOOKUP_FIELDS':
      return { ...state, lookupFields: action.fields };
    case 'SET_LOOKUP_VALUES':
      return { ...state, [action.field]: action.values };
    default:
      return state;
  }
};

export default LookupValues;
